var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3577_1606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22.3751V25.5001H13.625L22.8417 16.2835L19.7167 13.1585L10.5 22.3751ZM25.2583 13.8668C25.5833 13.5418 25.5833 13.0168 25.2583 12.6918L23.3083 10.7418C22.9833 10.4168 22.4583 10.4168 22.1333 10.7418L20.6083 12.2668L23.7333 15.3918L25.2583 13.8668Z",
    fill: "#28519E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#28519E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3577_1606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonedit);
export default __webpack_public_path__ + "static/media/Buttonedit.15ecc23f0e97b140408900acffecbbf9.svg";
export { ForwardRef as ReactComponent };